module.exports = __webpack_public_path__ + "static/media/team-member-03.78e63651.jpg";